/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputDeltaLogData
 */
export interface OutputDeltaLogData {
    /**
     * 
     * @type {string}
     * @memberof OutputDeltaLogData
     */
    eventTime?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputDeltaLogData
     */
    payload?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputDeltaLogData
     */
    status?: string;
}

/**
 * Check if a given object implements the OutputDeltaLogData interface.
 */
export function instanceOfOutputDeltaLogData(value: object): boolean {
    return true;
}

export function OutputDeltaLogDataFromJSON(json: any): OutputDeltaLogData {
    return OutputDeltaLogDataFromJSONTyped(json, false);
}

export function OutputDeltaLogDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputDeltaLogData {
    if (json == null) {
        return json;
    }
    return {
        
        'eventTime': json['eventTime'] == null ? undefined : json['eventTime'],
        'payload': json['payload'] == null ? undefined : json['payload'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function OutputDeltaLogDataToJSON(value?: OutputDeltaLogData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'eventTime': value['eventTime'],
        'payload': value['payload'],
        'status': value['status'],
    };
}

